module.exports = __webpack_public_path__ + "static/media/auto-transmission.7fe044df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarPage/images/auto-transmission.svg
// module id = 549
// module chunks = 0